import * as colors from './colors';
import breakpoints, { breakpointObj } from './breakpoints';
import radius from './radius';
import spacing from './spacing';
import * as fonts from './fonts';
import sizes from './sizes';
import stacking from './stacking';
import * as keyFrames from './keyFrames';
import iconSizes from './iconSizes';
export default {
  colors: colors,
  radius: radius,
  breakpointObj: breakpointObj,
  breakpoints: breakpoints,
  spacing: spacing,
  fonts: fonts,
  sizes: sizes,
  iconSizes: iconSizes,
  stacking: stacking,
  keyFrames: keyFrames
};